import React from "react";
import { Button,Text } from "@ui-component-library";

const WelcomeStep = ({ onNext}) => {
    return (
        <div className="h-full flex flex-col justify-center">
            <div className="w-full flex flex-col sm:items-center text-center">
                <Text variant="text-3xl/leading-none/bold" className="text-white mb-2">Få full koll på din skog - boka en kostnadsfri genomgång</Text>
                <Text variant="text-xl/leading-normal/normal" className="text-white mb-4">Vill du förstå din skog bättre och se hur Treebula kan hjälpa dig? Boka en personlig genomgång med en av våra rådgivare.</Text>
                <Text variant="text-base/leading-normal/normal" className="text-spring-yellow-500 mb-2">Fyll bara i formuläret nedan, så ringer vi upp dig och hjälper dig komma igång, helt kostnadsfritt och utan förpliktelse.</Text>
            </div>
            <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center">
                <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                    <Button
                        onClick={()=>onNext({data:{
                            step:"treeform_welcome"
                        }})}
                        variant="quaternary"
                        fullWidth
                    >
                        Starta
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default WelcomeStep;